import { Store } from 'laco'
import WebsocketService from 'Services/websocket'

const WebSocketStore = new Store({
  active: false,
  websocket: undefined
})

export const connectWebsocket = async () => {
  const ws = await WebsocketService.connect()
  WebSocketStore.set(() => ({ websocket: ws }))

  WebSocketStore.set(() => ({ active: true }))
}

export const closeWebsocket = async () => {
  const { active, websocket } = WebSocketStore.get()
  if (!active) return
  websocket.close()
  WebSocketStore.set(() => ({ websocket: undefined, active: false }))
}

export default WebSocketStore
